
<template>
  <!--编辑社区功能-->
  <x-editAppFun></x-editAppFun>
</template>

<script>
export default {
  name: 'editCommunityFun'
};
</script>



// WEBPACK FOOTER //
// src/components/systemSet/communityApp/editCommunityFun.vue